import { createWebHistory, createRouter } from "vue-router";
import NotFoundSection from "@/components/NotFoundSection.vue";
import AcreditadoSection from "@/components/AcreditadoSection.vue";
import AcreditadoVipSection from "@/components/AcreditadoVipSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";

const routes = [
  {
    path: "/",
    component: AcreditadoSection,
  },
  {
    path: "/vip",
    component: AcreditadoVipSection,
  },
  {
    path: "/finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/confirmacion/:hash",
    component: ConfirmacionMailSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

import { createWebHashHistory } from 'vue-router'
import ConfirmacionMailSection from "@/components/ConfirmacionMailSection.vue";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;